import { defineMessages } from 'react-intl';

const trns = defineMessages({
  sort: {
    id: 'AHeuGe',
    defaultMessage: 'Сортування:'
  },
  sortByDistanceAlphabetEnd: {
    id: 'bXBLJc',
    defaultMessage: 'За назвою (від Я до А)'
  },
  sortByDistanceAlphabetBeginning: {
    id: '2Qic54',
    defaultMessage: 'За назвою (від А до Я)'
  },
  sortByPopular: {
    id: '2E9dYG',
    defaultMessage: 'За популярністю'
  },
  sortByRelevance: {
    id: '1Fd4dV',
    defaultMessage: 'За релевантністю'
  },
  sortByCreateDateAsc: {
    id: 'y+PxHF',
    defaultMessage: 'Спочатку: актуальні'
  },
  sortByViewsAsc: {
    id: 'KG2uZh',
    defaultMessage: 'Спочатку: популярні'
  },
  sortByDistance: {
    id: 'FgvWFa',
    defaultMessage: 'За відстанню'
  },
  sortByPriceFromCheapToExpensive: {
    id: 'qw5Q0H',
    defaultMessage: 'Bід дешевих до дорогих'
  },
  sortByPriceFromExpensiveToCheap: {
    id: 'H4JMha',
    defaultMessage: 'Bід дорогих до дешевих'
  }
});

export default trns;
